var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 100,
    viewBox: "0 0 142 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_7944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.032 23.72V0.600006H21.804V88.104H31.528",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.032 23.72V0.600006H21.804V88.104H31.528",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M80.4441 4.18799H25.3921V84.516H80.4441V4.18799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7521 33.164V97.5H31.5281V9.996H70.7841L93.7521 33.164Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7519 33.196H70.7839V9.996L93.7519 33.196Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4519 22.568H39.0879V26.872H55.4519V22.568Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8039 37.656H39.0879V41.96H65.8039V37.656Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1919 52.744H39.0879V57.048H86.1919V52.744Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1919 67.836H39.0879V72.14H86.1919V67.836Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1919 82.924H39.0879V87.228H86.1919V82.924Z",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.7639 53H9.13192C6.55828 53 4.47192 55.0864 4.47192 57.66V77.78C4.47192 80.3536 6.55828 82.44 9.13192 82.44H43.7639C46.3376 82.44 48.4239 80.3536 48.4239 77.78V57.66C48.4239 55.0864 46.3376 53 43.7639 53Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.124 50.316H6.49203C3.91838 50.316 1.83203 52.4023 1.83203 54.976V75.096C1.83203 77.6696 3.91838 79.756 6.49203 79.756H41.124C43.6977 79.756 45.784 77.6696 45.784 75.096V54.976C45.784 52.4023 43.6977 50.316 41.124 50.316Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.456 59.572C53.8875 59.572 55.048 58.4115 55.048 56.98C55.048 55.5485 53.8875 54.388 52.456 54.388C51.0245 54.388 49.864 55.5485 49.864 56.98C49.864 58.4115 51.0245 59.572 52.456 59.572Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7199 57.968H7.48389V60.012H40.7199V57.968Z",
    fill: "url(#paint0_linear_719_7944)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7199 62.324H7.48389V64.368H40.7199V62.324Z",
    fill: "url(#paint1_linear_719_7944)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7199 66.676H7.48389V68.72H40.7199V66.676Z",
    fill: "url(#paint2_linear_719_7944)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7199 71.028H7.48389V73.072H40.7199V71.028Z",
    fill: "url(#paint3_linear_719_7944)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M134.308 28.756H83.836C81.4987 28.756 79.604 30.6507 79.604 32.988V53.548C79.604 55.8853 81.4987 57.78 83.836 57.78H134.308C136.645 57.78 138.54 55.8853 138.54 53.548V32.988C138.54 30.6507 136.645 28.756 134.308 28.756Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38 26.6H86.892C84.283 26.6 82.168 28.715 82.168 31.324V50.9C82.168 53.509 84.283 55.624 86.892 55.624H136.38C138.989 55.624 141.104 53.509 141.104 50.9V31.324C141.104 28.715 138.989 26.6 136.38 26.6Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.188 30.06H89.18C87.2735 30.06 85.728 31.6055 85.728 33.512V48.716C85.728 50.6225 87.2735 52.168 89.18 52.168H134.188C136.095 52.168 137.64 50.6225 137.64 48.716V33.512C137.64 31.6055 136.095 30.06 134.188 30.06Z",
    fill: "url(#paint4_linear_719_7944)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.752 64.296C80.5038 64.296 81.924 62.8758 81.924 61.124C81.924 59.3721 80.5038 57.952 78.752 57.952C77.0001 57.952 75.58 59.3721 75.58 61.124C75.58 62.8758 77.0001 64.296 78.752 64.296Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3841 44.176C99.0763 44.176 100.448 42.8042 100.448 41.112C100.448 39.4198 99.0763 38.048 97.3841 38.048C95.6919 38.048 94.3201 39.4198 94.3201 41.112C94.3201 42.8042 95.6919 44.176 97.3841 44.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.632 44.176C113.324 44.176 114.696 42.8042 114.696 41.112C114.696 39.4198 113.324 38.048 111.632 38.048C109.94 38.048 108.568 39.4198 108.568 41.112C108.568 42.8042 109.94 44.176 111.632 44.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.884 44.176C127.576 44.176 128.948 42.8042 128.948 41.112C128.948 39.4198 127.576 38.048 125.884 38.048C124.192 38.048 122.82 39.4198 122.82 41.112C122.82 42.8042 124.192 44.176 125.884 44.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.472 30.344C6.38953 30.344 7.944 28.7895 7.944 26.872C7.944 24.9545 6.38953 23.4 4.472 23.4C2.55447 23.4 1 24.9545 1 26.872C1 28.7895 2.55447 30.344 4.472 30.344Z",
    stroke: "#05CB67",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.624 71.804C104.762 71.804 105.684 70.8817 105.684 69.744C105.684 68.6063 104.762 67.684 103.624 67.684C102.486 67.684 101.564 68.6063 101.564 69.744C101.564 70.8817 102.486 71.804 103.624 71.804Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7441 99.56C20.8818 99.56 21.8041 98.6377 21.8041 97.5C21.8041 96.3623 20.8818 95.44 19.7441 95.44C18.6064 95.44 17.6841 96.3623 17.6841 97.5C17.6841 98.6377 18.6064 99.56 19.7441 99.56Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.932 12.064V18.02",
    stroke: "#05CB67",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.912 15.04H97.9561",
    stroke: "#05CB67",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_7944",
    x1: 7.48389,
    y1: 58.992,
    x2: 40.7199,
    y2: 58.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_719_7944",
    x1: 629.329,
    y1: 386.012,
    x2: 3390.91,
    y2: 386.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_719_7944",
    x1: 629.329,
    y1: 412.603,
    x2: 3390.91,
    y2: 412.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_719_7944",
    x1: 629.329,
    y1: 439.213,
    x2: 3390.91,
    y2: 439.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_719_7944",
    x1: 85.728,
    y1: 41.112,
    x2: 137.64,
    y2: 41.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_7944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.7,
    height: 99.56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.293b703ea2cfa7f6b5bc1db5cba008e7.svg";
export { ForwardRef as ReactComponent };